import React, { Component } from 'react';
import ClipLoader from 'halogen/ClipLoader';
import './Loading.css';

export default class Loading extends Component {
  render () {
    return (
      <div className="loading-wrapper">
        <center>
          <div className="loading-text-container">
            <ClipLoader color="#efefef" size="60px" margin="4px"/>
            <div className="loading-description">
              Loading ...
            </div>
          </div>
        </center>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/Loading.jsx